import { MedcardAuthModalAction, MedcardAuthModalState } from "./modals.medcardAuth.types";

export const medcardAuthModalSetAction = (modal: Partial<MedcardAuthModalState>): MedcardAuthModalAction => ({ type: 'MEDCARD_AUTH_MODAL_SET', params: modal })
export const medcardAuthModalCloseAction = (): MedcardAuthModalAction => ({ type: 'MEDCARD_AUTH_MODAL_CLOSE' })
export const medcardAuthModalClearAction = (): MedcardAuthModalAction => ({ type: 'MEDCARD_AUTH_MODAL_CLEAR' })